export type MiscCardsProps = {
    title: string,
    sentence: string,
    paragraph: string
}

export const miscCardsItems: MiscCardsProps[] = [
    {
        title: 'The Mighty Mr.MICO Visa Debit Card',
        sentence: 'Introducing a new way of banking that saves and invests for you.',
        paragraph: 'The titanium Mighty Mr.MICO Visa debit card turns every purchase and paycheck into an opportunity to save and invest for your future. Plus, grow your money faster with 3.00% APY on Checking and 5.00% APY on Emergency Fund - two of the highest APYs available today.'
    },
    {
        title: 'Mr.MICO Diamond Preferred',
        sentence: 'Earn 80,000 bonus points',
        paragraph: 'Worth $800 when redeemed for travel through The Rewards. Plus, get 5x points on travel and 3x on dining. Terms Apply.'
    },
    {
        title: 'Sponsered',
        sentence: 'The New Yorker',
        paragraph: 'Is Mr.MICO the hottest new finance app right now?'
    },
    {
        title: 'Home Lending',
        sentence: 'Take the easier way home',
        paragraph: 'Try our easy-to-use affordability calculator and see how much home you may be able to afford.'
    },
    {
        title: 'Business Credit Card',
        sentence: '$750 bonus cash back',
        paragraph: 'Plus, unlimited 1.5% cash back on every purchase with the Ink Business Unlimited credit card. Terms apply.'
    },
    {
        title: 'Mr.MICO Freedom Unlimited',
        sentence: 'Earn a $200 bonus + 5% gas and grocery store offer',
        paragraph: 'Plus earn unlimited 1.5% cash back or more on all purchases, including 3% on dining and drugstores -- all with no annual fee.'
    }
];